import type { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';
import type { Notification } from './components/NotificationList';

interface NotificationContextProps {
  notifications: Notification[];
  setNotifications: (notifications: Notification[]) => void;
}

const NotificationContext = createContext<NotificationContextProps>({
  notifications: [],
  setNotifications: () => {},
});

function NotificationProvider({ children }: { children: ReactNode }) {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  return (
    <NotificationContext.Provider value={{ notifications, setNotifications }}>
      {children}
    </NotificationContext.Provider>
  );
}

function useNotification() {
  return useContext(NotificationContext);
}

export { NotificationProvider, useNotification };
